export const filterApplicationsOrder = (applications) => {
  const statusOrder = [
    'IN PROGRESS',
    'SUBMITTED',
    'ACCEPTED',
    'APPROVED',
    'NO SCORE',
    'LOW SCORE',
    'CANCELLED',
    'EXPIRED',
    'DECLINED',
  ];
  if (!applications || applications.length === 0) {
    return [];
  }
  const clonedApplications = applications.slice(0);
  return clonedApplications.sort((a, b) => {
    const aI = statusOrder.indexOf(a.status);
    const bI = statusOrder.indexOf(b.status);

    if (aI < bI) {
      return -1;
    }

    if (aI > bI) {
      return 1;
    }

    return 0;
  });
};



// WEBPACK FOOTER //
// ./src/utils/helperFunctions.js